export default {
  header: '系统管理',
  auditTrail: {
    title: '动作稽查',
    function: '动作内容',
    user: '用户',
    actionDetail: '动作详情',
    actionDate: '最后行动日期',

  },
  bulletin: {
    title: '公告',
    category: '类别',
    category: '类别',
    header: '公告列表',
    bulletinList: '列表',
    create: '创建公告',
    edit: '修改',
    view: '检视',
    attachment: '附件',
    deleteConfirmTitle:'确认 "删除" 下列公告？',
    subject: '主题',
    content: '内容',
    createTime:'创建日期',
    updateTime:'修改日期',
    preview:'摘要',
  },

  agent: {
    ID: 'ID',
    agentList: '列表',
    create: '创建财务顾问',
    success: '创建 / 修改成功',
    confirmation: '确认 创建或修改 此财务顾问吗？',
    header: '财务顾问',
    agentInformation: '财务顾问详情',
    agentCode: '财务顾问代码',
    joinDate: '加入日期',
    leaveDate: '离职日期',
    agentTeam: '财务顾问团队',
    position: '职位',
    name: '财务顾问姓名',
    cibLicense: 'CIB 牌照',
    mpfaLicense: 'MPFA 牌照',

    ociLicensePrinciples: 'OCI 保险原理及实务',
    ociLicenseGeneral: 'OCI 一般保险',
    ociLicenseLongTerm: 'OCI 长期保险',
    ociLicenseLinkedLongTerm: 'OCI 投资相连长期保险',

    sfcLicenseType1: 'SFC 第1类牌照',
    sfcLicenseType2: 'SFC 第2类牌照',
    sfcLicenseType3: 'SFC 第3类牌照',
    sfcLicenseType4: 'SFC 第4类牌照',
    sfcLicenseType5: 'SFC 第5类牌照',
    sfcLicenseType6: 'SFC 第6类牌照',
    sfcLicenseType7: 'SFC 第7类牌照',
    sfcLicenseType8: 'SFC 第8类牌照',
    sfcLicenseType9: 'SFC 第9类牌照',
    sfcLicenseType10: 'SFC 第10类牌照',

    userEmail: '用户电邮',
    language: '偏好系统语言',
    marketingOptOut: '拒绝销售名单',
    license: '牌照详情',
    noAgentTeam: '无财务顾问团队',
    hasAgentTeam: '有财务顾问团队',
    search: '检索财务顾问',
    create: '创建财务顾问',
    contactType: '合约类别',
    idType: 'ID 类别',
    maritalStatus: '婚姻状况',

    parentAgent: '主要顾问',
    providerSplitRate: '保险公司分成比率',
    fyc: '首年佣金',
    provider: '保险公司',
    commission: '第二年后佣金',
    defaultSplitRate: {
      header: '预设抽成比率',
    },
    editSplitRate: '编辑保险公司指定分成率',
    overrideSplitRate: '改写所有保险公司分成率',
    noParentAgent: '毋主要兴问',
    hasParentAgent: '有主要顾问',

    agentSplitModal: {
      editAgentSplitRate: '编辑保险公司指定分成率',
      editAgentSplitRateBody: '编辑保险公司指定分成率只会影响个名保险公司',
      overrideAgentSplitRate: '改写所有保险公司分成率',
      overrideAgentSplitRateBody: '改写分成率会影响所有此顾问相关之分成率'
    }
  },

  document: {
    listTitle: '文件管理',
    download: '下载',
    remove: '移除',
    fields: {
      'ID': '编号',
      'documentName': '文件名称',
      'linkedEntity': '相关个体',
      'fileSize': '档案大小',
      'documentType': '文档类别',
      'publicDocument': '公开文件',
      'documentTag': '文件标签',
      'remarks': '备注',
      'createTime': '创建时间',
      'createUser': '新增用户',
      'actions': '行动',
    }
  },

  product: {
    list: {
      title: '产品管理',
      search: '搜寻产品',

    },
    create: {
      successMsg: '成功新增产品',
      title: '新增产品',
    },
  },

  contents: {
    EntityManagement: {
      title: '个体管理',
      search: "搜寻",
      perPage: '每页',
      total: '总数',
      records: '纪录',
      createBtn: '新增',

      // Core Session
      Core: {
        header: '主个体',
        name: '主',
        contact: { title: '联络', },
        customer: { title: '客户', },
        address: { title: '地址', },
        agent: { title: '顾问', },
        lead: { title: '联络', },
        message: { title: '信息', },
        user: { title: '用户', },
        team: { title: '团队' }
      },

      OSMLife: {
        header: 'OSM-Life Entity',
        name: 'OSM 人寿',
        product: { title: '产品', },
        policy: { title: '保单', },
        policyPremium: { title: '保单费用', },
        paymentHistory: { title: '付款纪录', },
        policyFund: { title: '保单资金', },
        investmentStrategy: { title: '投资策略', },
        transactionHistory: { title: '交易历史', },
        outstandingRequirement: { title: 'OR' },
        outstandingRequirementComment: { title: 'OR 回应', },
        insuredBenefits: { title: '受保利益', },
        pendingOperation: { title: '待办操作', },
        commission: { title: '佣金', },
        commissionOverride: { title: '抽成佣金', },
      },

      OSMGI: {
        header: 'OSM-一般保险个体',
        name: 'OSM - 一般保险借贷',
        generalPolicy: { title: '一般保险单' },
        loanContract: { title: '借贷合约' },
      },
      DM: {
        header: '文件管理',
        name: 'DM',
        document: { title: '文件' },
      },
      System: {
        name: '系统管理',
        systemLogs: { title: '系统记录' },
        entitlement: { title: '权利' },
      },
      productManagement: {
        header: '产品',
      },
    }
  },

  userAuthorization: {
    title: '授权',
    header: '用户授权',

    change: {
      modal: {
        title: '确认要应用这些变更',
        body: '变更会于确认后立即生效'
      },
      header: '变更用户授权',
      selectedCandidate: '已选择用户',
      role: '角色',
      applyChanges: '使用变更'
    },
    list: {
      userType: '用户类别',
      referenceCode: '参考编号',
      success: '成功变更用户授权',
      error: '变更用户授权发生错误',
      edit: '编辑',
      header: '用户授权列表',
      englishName: 'English Name / 中文名',
      roleName: '角色名称'
    }
  },
  team: {
    header: '团队',
    list: '列表',
    teamCode: '团队编号',
    leader: '领袖',
    leaderCode: '领袖顾问编号',
    numberOfMember: '队员人数',
    createTeam: '创建团队',
    editTeam: '编辑团队',
    parentTeam: '主团队',
    haveParentTeam: '有主团队?',
    addAgent: '增加顾问',
    removeAgent: '移除顾问',
    addAgentComfirm: '<h4>确认要 <b>增加</b> 以下顾问到此团队?</h4> <br/> <p>顾问名称: {agentName}</p>',
    removeAgentComfirm: '<h4>确认要 <b>删除</b> 以下顾问?</h4> <br/> <p>顾问名称: {agentName}</p>',
  }
}


// WEBPACK FOOTER //
// ./src/Adm/langs/zh_cn/index.js